import { AppState } from '../../helpers/store/AppState';

const selectAuth = (state: AppState) => state.auth;

export const selectIsLogged = (state: AppState) => !!selectAuth(state).user;

export const selectLoggedUser = (state: AppState) => selectAuth(state).user;

export const selectAuthLoading = (state: AppState) => selectAuth(state).loading;
